export default __webpack_public_path__ + "static/media/Boots of Dark Terror.4b981d01.jpg";